import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Visual breadcrumb bar. Pair with SEO's `breadcrumbs` prop for JSON-LD.
 * Props: items = [{name, path}]  (do NOT include Home — it's added).
 */
export default function Breadcrumbs({ items = [] }) {
  const trail = [{ name: "Home", path: "/" }, ...items];
  return (
    <nav aria-label="Breadcrumb" className="text-xs text-stone-500 mb-3">
      <ol className="flex flex-wrap items-center gap-1">
        {trail.map((c, i) => {
          const last = i === trail.length - 1;
          return (
            <li key={c.path} className="flex items-center gap-1">
              {i === 0 ? <Home size={12} className="opacity-70" /> : null}
              {last ? (
                <span aria-current="page" className="text-stone-600">{c.name}</span>
              ) : (
                <Link to={c.path} className="hover:text-[color:var(--vv-gold-deep)] transition-colors">{c.name}</Link>
              )}
              {!last && <ChevronRight size={12} className="opacity-50" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
